const SceneBase = require("./scene-base.js");

class SceneScript extends SceneBase {
    static type() {
        return "scenescript";
    }
}

module.exports = SceneScript;